export const topArticle = {
  loc: null,
  isLike: 1,
  plainTextContent:
    '2023年來臨～我們將邁向不一樣的課題，你在新的一年對感情有什麼期許嗎？今天一起透過塔羅牌占卜2023戀愛運勢吧！現在將腦袋所有思緒排空，把眼睛閉上並靜下心後，默念題目再睜開眼，選出一張最有感覺的塔羅牌，往下滑立刻揭曉運勢吧！ 憑直覺選出一張最有感覺的塔羅牌 選好後下滑看答案！ – – – – – – （1）女祭司 在愛情塔羅牌中的女祭司暗藏著更高的力量、內在的聲音，表達平時彼此相處的情緒狀態很難被察覺，或是會有無意識的變化，看似平靜的表面背後隱藏強烈的情緒，即使是平凡簡單的約會，也有可能轉變為洶湧的激情。 在接下來的愛情指引裡，需要耐心等待並相信自己的直覺，對他人和自己誠實為主要前提，讓過去的疑惑和不確定性得到解答，如此一來，在與他人的關係中也會越來越親近、彼此更敞開心胸，「誠實」將會是感情升溫的關鍵！ （2）女皇 女皇象徵著喜悅和高貴，新的一年異性緣會特別旺，常常成為異性矚目的焦點，不管是單身者又或者有心儀對象者，都有機會認識到不錯的對象，並收獲一段美好的戀情，感情發展也會意外輕鬆順利，而如果有論及婚嫁的對象，未來和伴侶的感情在相處、心靈上都是自在又歡樂，更加速認定彼此！ （3）力量 這是一張充滿力量和勇氣的愛情塔羅牌，意味著你擁有足夠的力量、勇氣讓感情發展得越來越親密，不要害怕被對方控制，或急著把事情掌握在手中，你將會有足夠的勇氣去處理可能會發生的困難，也要相信另一半願意互相傾聽及傾訴，甚至互相扶持。值得注意的是女方可能操之過急而太過強勢，要適時放手給對方表現才能讓感情更加溫和發展！ 同場加映：塔羅牌指引「充滿力量」必收小物 講到現在的新世代女性，每位女孩都擁有超吸引人的柔韌女力～獨立又堅強的個性散發著迷人又溫柔的自信，追求精緻和完美的標準一刻都不停歇！身為顏值控的波編，面對忙碌的生活對保養也不馬虎，打造稚嫩肌全靠保濕力量超足夠的蘭蔻小黑瓶「超未來肌因賦活露」，內含有的專利BIO-7微生態科技，專注建立肌膚平衡，從肌表到肌底都能達到完整修護，輕鬆解決18～45歲的肌膚困擾，堪稱跨世代級別的保養精華！ 像是25歲女孩在意的保濕、透亮、柔嫩，或30歲時在乎的彈潤亮、緊緻毛孔，甚至40歲要追求的保濕與細緻彈力，都能透過一瓶小黑瓶達成，值得一提的是臉上冒出的小顆粒、粗糙暗沉也在使用後得到了救贖！肌膚的超有感穩定來自小黑瓶的BIO-7微生態專利，以7大益生菌萃取+益生質，一滴釋放3000萬活性益菌粹取，讓肌膚美得無可挑剔！ source:IG/@cccuuu0125 （4）戀人牌 戀人牌代表著一段新關係的開始，或是關係昇華到下一階段，原本處於觀望者將會轉變為決策者，決定一段新關係發展的開始。單身者有機會與朋友成為戀人，與曖昧、觀察對象一起沈醉於愛情的滋潤，而有對象者也會與另一半感情更加升溫、融洽而甜蜜，相處的目標也會朝長期穩定規劃，長期穩定者則有機會步入結婚殿堂！ （5）金幣八 金幣有傳達同理、耐心之意，在感情中難免會因為成就和功勞產生自豪感，不過別忘了停下腳步欣賞另一半的優點，嘗試誇獎對方為自己的付出，才會讓對方感受到在乎，而控制情緒處理事情更能體現你獨特的魅力之處，讓彼此的距離更加靠近。除此之外，互相扶持才會讓感情發展得健康、長久，在打拼事業之餘也要多給予彼此關心。 占卜完以上的戀愛塔羅牌，有沒有覺得對戀愛運勢更有頭緒了呢？無論如何，保有誠實、真心對待另一半，並好好珍惜身邊的他～絕對是彼此走向甜蜜的上上策！波編祝各位2023年幸福順利～ *以上皆大眾趣味占卜，每個人狀況不同，還是要依照個人實際狀況而定喔！ #測2023運勢',
  img: [
    {
      id: '63be8249e8c692ae52225c92',
      w: 1560,
      h: 800,
      path: 'u/202301/8b0766dd-fefa-4876-8f84-38ab1490cf6e.jpg',
      thumb: 'u/202301/0cf485a2-ccc9-4789-b7b8-d77760c785c2.jpg',
      caption: '',
      originalPath: 'u/202301/8b0766dd-fefa-4876-8f84-38ab1490cf6e.jpg',
    },
  ],
  editorType: 'wordpress',
  hashTags: ['測2023運勢'],
  saved: 6,
  reply: 0,
  ptype: 1,
  text: '',
  newText: [
    {
      type: 'paragraph',
      data: {
        text: '2023年來臨～我們將邁向不一樣的課題，你在新的一年對感情有什麼期許嗎？今天一起透過塔羅牌占卜2023戀愛運勢吧！現在將腦袋所有思緒排空，把眼睛閉上並靜下心後，默念題目再睜開眼，選出一張最有感覺的塔羅牌，往下滑立刻揭曉運勢吧！',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '憑直覺選出一張最有感覺的塔羅牌',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '選好後下滑看答案！',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/d93zfm8swdkokgo8wc84so48sro9lrt.jpg',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '–',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '（1）女祭司',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/58fuzvhscq04ockk4cggk0gkro9hyt.jpg',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '在愛情塔羅牌中的女祭司暗藏著更高的力量、內在的聲音，表達平時彼此相處的情緒狀態很難被察覺，或是會有無意識的變化，看似平靜的表面背後隱藏強烈的情緒，即使是平凡簡單的約會，也有可能轉變為洶湧的激情。',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '在接下來的愛情指引裡，需要耐心等待並相信自己的直覺，對他人和自己誠實為主要前提，讓過去的疑惑和不確定性得到解答，如此一來，在與他人的關係中也會越來越親近、彼此更敞開心胸，「誠實」將會是感情升溫的關鍵！',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '（2）女皇',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/ehk80qyj8xwkscg8g84ko084oro9hzz.jpg',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '女皇象徵著喜悅和高貴，新的一年異性緣會特別旺，常常成為異性矚目的焦點，不管是單身者又或者有心儀對象者，都有機會認識到不錯的對象，並收獲一段美好的戀情，感情發展也會意外輕鬆順利，而如果有論及婚嫁的對象，未來和伴侶的感情在相處、心靈上都是自在又歡樂，更加速認定彼此！',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '（3）力量',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/4nfev190qby8gow8sckc8gsc0ro9i1l.jpg',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '這是一張充滿力量和勇氣的愛情塔羅牌，意味著你擁有足夠的力量、勇氣讓感情發展得越來越親密，不要害怕被對方控制，或急著把事情掌握在手中，你將會有足夠的勇氣去處理可能會發生的困難，也要相信另一半願意互相傾聽及傾訴，甚至互相扶持。值得注意的是女方可能操之過急而太過強勢，要適時放手給對方表現才能讓感情更加溫和發展！',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '同場加映：塔羅牌指引「充滿力量」必收小物',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '講到現在的新世代女性，每位女孩都擁有超吸引人的柔韌女力～獨立又堅強的個性散發著迷人又溫柔的自信，追求精緻和完美的標準一刻都不停歇！身為顏值控的波編，面對忙碌的生活對保養也不馬虎，打造稚嫩肌全靠保濕力量超足夠的蘭蔻小黑瓶「超未來肌因賦活露」，內含有的專利BIO-7微生態科技，專注建立肌膚平衡，從肌表到肌底都能達到完整修護，輕鬆解決18～45歲的肌膚困擾，堪稱跨世代級別的保養精華！',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/29o0rogafgu8kwcokwocwg48wro9idd.png',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '像是25歲女孩在意的保濕、透亮、柔嫩，或30歲時在乎的彈潤亮、緊緻毛孔，甚至40歲要追求的保濕與細緻彈力，都能透過一瓶小黑瓶達成，值得一提的是臉上冒出的小顆粒、粗糙暗沉也在使用後得到了救贖！肌膚的超有感穩定來自小黑瓶的BIO-7微生態專利，以7大益生菌萃取+益生質，一滴釋放3000萬活性益菌粹取，讓肌膚美得無可挑剔！',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/9ay31vbay50cs8wk8cowsk8s8ro9iek.png',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: 'source:IG/@cccuuu0125',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '（4）戀人牌<br>\n<img class="alignnone size-full wp-image-803485" src="https://static.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7.jpg" alt="" width="1080" height="1920" srcset="https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7.jpg 1080w, https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7-338x600.jpg 338w, https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7-563x1000.jpg 563w, https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7-768x1365.jpg 768w, https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7-140x249.jpg 140w, https://www.popdaily.com.tw/wp-content/uploads/2023/01/ehbahocbh3wwsok8csk4o04swro9ih7-350x622.jpg 350w" sizes="(max-width: 1080px) 100vw, 1080px">',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '戀人牌代表著一段新關係的開始，或是關係昇華到下一階段，原本處於觀望者將會轉變為決策者，決定一段新關係發展的開始。單身者有機會與朋友成為戀人，與曖昧、觀察對象一起沈醉於愛情的滋潤，而有對象者也會與另一半感情更加升溫、融洽而甜蜜，相處的目標也會朝長期穩定規劃，長期穩定者則有機會步入結婚殿堂！',
      },
    },
    {
      type: 'header',
      data: {
        level: 3,
        text: '（5）金幣八',
      },
    },
    {
      type: 'image',
      data: {
        file: {
          url: 'https://static.popdaily.com.tw/wp-content/uploads/2023/01/ajtmbghtark0owg0kk848ook8ro9iid.jpg',
        },
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '金幣有傳達同理、耐心之意，在感情中難免會因為成就和功勞產生自豪感，不過別忘了停下腳步欣賞另一半的優點，嘗試誇獎對方為自己的付出，才會讓對方感受到在乎，而控制情緒處理事情更能體現你獨特的魅力之處，讓彼此的距離更加靠近。除此之外，互相扶持才會讓感情發展得健康、長久，在打拼事業之餘也要多給予彼此關心。',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '占卜完以上的戀愛塔羅牌，有沒有覺得對戀愛運勢更有頭緒了呢？無論如何，保有誠實、真心對待另一半，並好好珍惜身邊的他～絕對是彼此走向甜蜜的上上策！波編祝各位2023年幸福順利～',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '*以上皆大眾趣味占卜，每個人狀況不同，還是要依照個人實際狀況而定喔！',
      },
    },
    {
      type: 'paragraph',
      data: {
        text: '#測2023運勢',
      },
    },
  ],
  url: 'https://www.popdaily.com.tw/love/1365198',
  firstPublishedAt: '2023-01-11T09:32:57.645Z',
  authorRoles: ['editor'],
  secretColor: '#d1c6aa',
  contentType: 'PGC',
  t: 1673429572000,
  like: 20,
  title:
    '【2023戀愛塔羅占卜】今年與對方有機會昇華到下一階段嗎？他心裡想什麼呢？挑張戀愛塔羅告訴你吧～',
  userInfo: {
    mid: '245',
    name: '波波邱比特',
    img: 'u/201808/8ba9afac-d5c9-4734-a714-6755393cd2f1.jpg',
  },
  type: 'user',
  id: '63be8249e8c6920b44225c93',
  postID: 'love.1365198',
  clas: ['love'],
  isSaved: 0,
  ut: 1673429577645,
}
